const HISTORY = (function () {
    // dim active event
    function handleScroll() {
        if (window.scrollY === 0) {
            document.body.classList.remove('scroll');
        } else {
            document.body.classList.add('scroll');
        }
    }

    window.addEventListener('scroll', handleScroll);

    handleScroll();
    
    // text-area effect
    const boxWrap = document.querySelectorAll('.page-history .box-wrap');
    const textArea = document.querySelectorAll('.page-history .text-area');
    const textBox = document.querySelectorAll('.page-history .text-inner');

    for (let i = 0; i < textArea.length; i++) {
        ScrollTrigger.create({
            trigger: boxWrap[i],
            start: 'top 40%',
            end: 'bottom bottom',
            scrub: true,
            onEnter: function () {
                boxWrap[i].classList.add('on');
                textArea[i].classList.add('on');
            },
        });
    }

    // progress bar
    const progressBar = document.querySelectorAll('.page-history .line-area .fill');
    const progressBox = document.querySelectorAll('.page-history .line-area .fill-box');

    for (let i = 0; i < boxWrap.length; i++) {
        const scrollProgress = gsap.timeline();
        scrollProgress.addLabel('a').to(progressBar[i], { scaleY: 1 }, 'a').to(progressBox[i], { scaleY: 1 }, 'a');

        ScrollTrigger.create({
            animation: scrollProgress,
            trigger: boxWrap[i],
            start: 'top 50%',
            end: 'bottom-=300 60%',
            scrub: true,
        });
    }
    // progress circle
    boxWrap.forEach((box, boxIndex) => {
        const historyPoint = box.querySelectorAll('.history-title:not(.no-circle)');
        const textHeight = textArea[boxIndex].offsetHeight;
        const lineHeight = box.querySelector('.line').offsetHeight;
        let progressCurr = 0;
        let circleOffset = 0;

        window.addEventListener('scroll', function () {
            historyPoint.forEach((item, itemIndex) => {
                progressCurr = progressBar[boxIndex].getBoundingClientRect().height;
                circleOffset = item.offsetTop + item.offsetHeight / 2;

                if (textHeight > lineHeight) {
                    // 텍스트 영역의 높이가 line의 높이보다 클경우 백분율로 전환해서 비교
                    if (boxIndex == 0) {
                        progressCurr = ((historyPoint[0].offsetTop + progressCurr) / lineHeight) * 100;
                    } else {
                        progressCurr = (progressCurr / lineHeight) * 100;
                    }
                    circleOffset = (circleOffset / textHeight) * 100;
                } else {
                    // 텍스트 영역이 라인보다 작거나 같은 경우 픽셀값으로 비교
                    if (boxIndex == 0) {
                        progressCurr = historyPoint[0].offsetTop + progressCurr;
                    }
                }

                if (progressCurr > circleOffset) {
                    item.classList.add('on');
                } else {
                    item.classList.remove('on');
                }
            });
        });
    });
})();
